module.exports = __webpack_public_path__ + "media/packs/App/assets/fonts/materialdesignicons-webfont-bd5c85afa91031c7cdcad3c48541daa1.woff";